import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function packageTemplates() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            limit: 25,
            page: 1,
            pattern: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`template-pack/search${params}`);
    }

    function get(templateId) {
        return axiosInstance.get(`template-pack/get?id=${templateId}`);
    }

    function create(payload) {
        return axiosInstance.post('template-pack/new', payload);
    }

    function update(payload) {
        return axiosInstance.patch('template-pack/update', payload);
    }

    function remove(templateId) {
        return axiosInstance.delete(`template-pack/delete`, {
            data: {
                id: templateId
            }
        });
    }
}
